import { SUCCESS_GIFT_CODE, ERROR_GIFT_CODE } from '../../actionType';
import giftcodeApiEpay from '../api/epay';

export const successGetGiftCode = payload => ({
	type: SUCCESS_GIFT_CODE,
	payload
});
export const errorGetGiftCode = payload => ({
	type: ERROR_GIFT_CODE,
	payload
});

export const verifyGiftCode = data => async dispatch => {
	/*const response = {
		status: 'success',
		message: 'Code available to be redeemed',
		giftCode: { code: 'egn1wqvqv81k', id: '401', status: 'ACTIVATED' },
		plan: {
			id: '11',
			signatureType: 'saude',
			value: '179.70',
			name: 'YALO Sa\u00fade Trimestral'
		}
	};
	let hasError = '';
	dispatch(successGetGiftCode(response));
	return (hasError = false); //mock
 */
	try {
		const giftCodeResponse = await giftcodeApiEpay.sendingCode(data);
		let hasError = '';
		if (giftCodeResponse === undefined) {
			//dispatch(errorGetGiftCode(giftCodeResponse));
			hasError = true;
		} else if (giftCodeResponse.data.status === 'success') {
			dispatch(successGetGiftCode(giftCodeResponse.data));
			hasError = false;
		} else {
			hasError = 'true1';
		}
		return hasError;
	} catch (err) {}
	//
};
